import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
// In sviluppo: undefined => usa window.location (il dominio corrente, anche ngrok).
// Il dev server inoltra /socket.io a localhost:3500 (vedi src/setupProxy.js).
const URL = process.env.NODE_ENV === 'production' ? 'https://webapp.wine2trace.com' : undefined;
// const URL = 'https://webapp.wine2trace.com';

// by default, the Socket.IO client opens a connection to the server right away.
// To prevent this behavior set autoConnect: false

export const socket = io(URL, {
  path: "/socket.io",
  transports: ["websocket"], // force WebSocket only
  autoConnect: false, // disable autoConnect to control it manually
  // autoConnect: true, // disable autoConnect to control it manually
  reconnection: true,
  reconnectionAttempts: Infinity, // try forever
  reconnectionDelay: 2000, // initial delay
  reconnectionDelayMax: 10000, // max delay
  timeout: 20000, // connection timeout
  ackTimeout: 10000,
  pingInterval: 25000,
  pingTimeout: 20000,

  // autoConnect: true,
  // reconnection: true,
  // reconnectionDelay: 5000, // defaults to 1000
  // reconnectionDelayMax: 10000, // defaults to 5000
  // ackTimeout: 10000,
  // retries: 3,
  // auth: {
  //   token: "123"
  // },
});